import { render, staticRenderFns } from "./o-project-wrapper.vue?vue&type=template&id=4e65c584&scoped=true&"
import script from "./o-project-wrapper.vue?vue&type=script&lang=js&"
export * from "./o-project-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./o-project-wrapper.vue?vue&type=style&index=0&id=4e65c584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65c584",
  null
  
)

export default component.exports